<div class="container">
    <h2 class="text-secondary">Informes de las solicitudes de servicio</h2>

    <br><br>

    <div class="d-flex container flex-column gap-5">
        <div class="row">
            <div class="col-md-4">
                <label for="id" class="form-label">Tipo de informe</label>
                <select class="form-select" aria-label="Default select example"
                    [(ngModel)]="tipoInforme" name="tipoFecha"
                    #tipoFecha="ngModel" required>
                    <option selected disabled>Seleccionar</option>
                    <option *ngFor="let typeTypeReport of $parametricList.typeTypeReport"
                        [value]="typeTypeReport.idParametroDetalle">
                        {{ typeTypeReport.vcNombre }}
                    </option>
                </select>

                <strong class="invalid-feedback d-block"
                    *ngIf="tipoFecha.invalid && (tipoFecha.dirty || tipoFecha.touched)">
                    <span *ngIf="tipoFecha.errors?.['required']">
                        Campo obligatorio
                    </span>
                </strong>
            </div>

            <div class="col-md-4">
                <label for="dtFechaInicial" class="form-label">Fecha Inicial</label>
                <input id="dtFechaInicial" class="form-control" type="date" required
                    [(ngModel)]="dataSearch.dtFechaInicio" #fechaInicial="ngModel" name="dtFechaInicial"
                    [max]="dataSearch.dtFechaFin">

                <strong class="invalid-feedback d-block"
                    *ngIf="fechaInicial.invalid && (fechaInicial.dirty || fechaInicial.touched)">
                    <span *ngIf="fechaInicial.errors?.['required']">
                        Campo obligatorio
                    </span>
                </strong>
            </div>

            <div class="col-md-4">
                <label for="dtFechaFinal" class="form-label">Fecha Final</label>
                <input id="dtFechaFinal" class="form-control" type="date" required
                    [(ngModel)]="dataSearch.dtFechaFin" #fechaFinal="ngModel" name="dtFechaFinal"
                    [min]="dataSearch.dtFechaInicio">

                <strong class="invalid-feedback d-block"
                    *ngIf="fechaFinal.invalid && (fechaFinal.dirty || fechaFinal.touched)">
                    <span *ngIf="fechaFinal.errors?.['required']">
                        Campo obligatorio
                    </span>
                </strong>
            </div>
        </div>

        <div class="col">
            <div class="col-md-6 mb-4" *ngIf="tipoInforme == $parametricList.typeTypeReport[1]?.idParametroDetalle">
                <label for="id" class="form-label">Preguntas de la encuesta de satisfacción</label>
                <select class="form-select" aria-label="Default select example"
                    [(ngModel)]="dataSearch.encuestaPreguntaId" name="tipoFecha"
                    #tipoFecha="ngModel" required>
                    <option selected disabled>Seleccionar</option>
                    <option *ngFor="let pregunta of preguntasEncuesta; let i = index"
                        [value]="pregunta.id">
                        {{i+1}} {{pregunta.vcNombre}}
                    </option>
                </select>

                <strong class="invalid-feedback d-block"
                    *ngIf="tipoFecha.invalid && (tipoFecha.dirty || tipoFecha.touched)">
                    <span *ngIf="tipoFecha.errors?.['required']">
                        Campo obligatorio
                    </span>
                </strong>
            </div>

            <div class="col-md-4">
                <button class="btn btn-secondary col-md-6" (click)="onConsult()" [disabled]="tipoFecha.invalid || fechaInicial.invalid || fechaFinal.invalid">CONSULTAR</button>
            </div>
        </div>
    </div>

    <br><br>

    <!-- TABLA INFORME DE SOLICITUDES DE SERVICIO -->
    <div>
        <app-table-request-report *ngIf="tipoInforme == $parametricList.typeTypeReport[0]?.idParametroDetalle"
            [dataTable]="dataTableRequest"
            (export)="onExport($event)">
        </app-table-request-report>
    </div>

    <app-table-satisfaction-survey *ngIf="tipoInforme == $parametricList.typeTypeReport[1]?.idParametroDetalle"
        [dataTable]="dataTableSurvey"
        (export)="onExport($event)">
    </app-table-satisfaction-survey>

    <br><br>

    <div class="d-flex flex-row mb-4">
        <button class="btn btn-secondary col-2 m-1" [routerLink]="['/bandeja-programador']">REGRESAR</button>
    </div>
</div>